import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, ShoppingBag, Heart, User, LayoutGrid } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export default function MobileNav() {
  const { pathname } = useLocation();
  const { count, wishlist, setMenuOpen } = useCart();
  const { user } = useAuth();

  const items = [
    { icon: Home, label: "Home", to: "/", testid: "mnav-home" },
    { icon: LayoutGrid, label: "Shop", action: () => setMenuOpen(true), testid: "mnav-shop" },
    { icon: Heart, label: "Wishlist", to: "/wishlist", badge: wishlist.length, testid: "mnav-wishlist" },
    { icon: ShoppingBag, label: "Bag", to: "/cart", badge: count, testid: "mnav-cart" },
    { icon: User, label: "Account", to: user ? "/account" : "/login", testid: "mnav-account" },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-ivory/95 backdrop-blur-lg border-t border-champagne/20 flex justify-around items-center h-16 px-2 safe-bottom" data-testid="mobile-bottom-nav">
      {items.map((it) => {
        const active = it.to && pathname === it.to;
        const inner = (
          <>
            <it.icon className={`w-5 h-5 ${active ? "text-champagne" : "text-espresso/60"}`} />
            {it.badge > 0 && (
              <span className="absolute top-0 right-1/4 bg-champagne text-espresso text-[9px] w-4 h-4 rounded-full flex items-center justify-center font-semibold">{it.badge}</span>
            )}
            <span className={`text-[10px] font-sans ${active ? "text-champagne" : "text-espresso/60"}`}>{it.label}</span>
          </>
        );
        return it.action ? (
          <button key={it.label} onClick={it.action} className="flex flex-col items-center gap-1 relative flex-1" data-testid={it.testid}>{inner}</button>
        ) : (
          <Link key={it.label} to={it.to} className="flex flex-col items-center gap-1 relative flex-1" data-testid={it.testid}>{inner}</Link>
        );
      })}
    </nav>
  );
}
